import {
  ButtonBack,
  ButtonFirst,
  ButtonLast,
  ButtonNext,
  ButtonPlay,
  CarouselProvider,
  Slider,
} from "pure-react-carousel";
import React, { useEffect, useState } from "react";
import { ButtonGroup, Container } from "react-bootstrap";
import { famousPersonsData } from "../../../utils/famousPersonsData";
import FamousPerson from "./FamousPerson";
import styled from "styled-components";

function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

const FamousPersons = () => {
  const [slide, setCurrentSlide] = useState(0);
  const [slideCount, setSlideCount] = useState(4);

  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);
    console.log(windowSize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <Container fluid className="mt-5 pt-3 pb-2 famous-person-container">
      <CarouselWrapper className="carousel-container">
        <CarouselProvider
          visibleSlides={slideCount}
          totalSlides={8}
          step={1}
          naturalSlideHeight={250}
          naturalSlideWidth={420}
          currentSlide={slide}
          infinite={true}
          lockOnWindowScroll
          isPlaying
          className="w-full"
        >
          <Slider className="mb-3">
            {famousPersonsData.map((famousPersons) => (
              <FamousPerson
                famousPersons={famousPersons}
                key={famousPersons.id}
              />
            ))}
          </Slider>
          <div className="slider-options d-flex align-items-center justify-content-center">
            <ButtonGroup size="sm" aria-label="carousel button group">
              <ButtonPlay
                className="btn btn-light border-0"
                childrenPlaying="Pause"
                childrenPaused="Play"
              />
              <ButtonFirst className="border-0 btn btn-light">
                First
              </ButtonFirst>
              <ButtonBack className="border-0 btn btn-light">Back</ButtonBack>
              <ButtonNext className="border-0 btn btn-light">Next</ButtonNext>
              <ButtonLast className="border-0 btn btn-light">Last</ButtonLast>
            </ButtonGroup>
          </div>
        </CarouselProvider>
      </CarouselWrapper>
    </Container>
  );
};

const CarouselWrapper = styled.div`
  &.carousel-container {
    margin: 12px auto;
    filter: drop-shadow(0px 3px 5px rgba(50, 50, 50, 0.2));

    @media screen and (min-width: 832px) {
      max-width: 704px;
    }

    @media screen and (min-width: 1088px) {
      max-width: 960px;
    }

    @media screen and (min-width: 1272px) {
      max-width: 1152px;
    }

    @media screen and (min-width: 1504px) {
      max-width: 1344px;
    }
  }

  .carousel__inner-slide {
    /* width: 100% - margin */
    width: calc(100% - 16px);
    /* margin-left: margin/2 */
    /* margin is required to adjust positioning as the width is diminished*/
    margin-left: 8px;

    @media screen and (min-width: 1272px) {
      width: calc(100% - 24px);
      margin-left: 12px;
    }

    @media screen and (min-width: 1272px) {
      width: calc(100% - 32px);
      margin-left: 16px;
    }
  }
`;

export default FamousPersons;
